import { PLAN_FEATURES } from '@scio3/shared-types';

/**
 * On the **Engage plan** a standalone **Engage add-on** is redundant — the plan covers Engage on every
 * screen account-wide, so the per-device add-on is cancelled + credited on an upgrade to Engage. Any
 * summary/subtotal that still lists it over-states the charge (B19 preview↔commit divergence).
 *
 * Mirrors the backend commit (`change.subscription.service.ts` engage-plan branch) + preview
 * (`billing.service.getUpcomingSubscriptionReview`), and the existing FE filter in `buildAddonList.ts`.
 * The `'engage'` add-on key is a literal per the billing-feature convention (no key constant here; the
 * `ENGAGE_ADDON_TYPE` constant lives in the screens feature — importing it would be a cross-feature smell).
 */
export function isEngageAddonRedundantOnPlan(
  addonKey: string,
  targetPlanAlias: string | undefined,
): boolean {
  return targetPlanAlias === PLAN_FEATURES.ENGAGE && addonKey === 'engage';
}
